import React, { useState, useEffect } from 'react';
import { sendFrontAction, getBackendFileUrl } from '../../services/api';
import { validateName, validatePhone, validateEmail, normalizePhoneUZ, hasErrors } from '../../utils/validation';
import './TestDriveAppointment.css';

const TestDriveAppointment = () => {
    // Получаем текущие данные времени с ПК пользователя
    const todayObj = new Date();
    const currentYear = todayObj.getFullYear();
    const currentMonth = todayObj.getMonth();
    const currentDate = todayObj.getDate();

    const [vehicles, setVehicles] = useState([]);

    // СТЭЙТЫ ДЛЯ НАВИГАЦИИ ПО КАЛЕНДАРЮ
    const [activeMonth, setActiveMonth] = useState(currentMonth);
    const [activeYear, setActiveYear] = useState(currentYear);

    // ОСНОВНЫЕ СТЭЙТЫ ФОРМЫ
    const [step, setStep] = useState(1);
    const [selectedDealer, setSelectedDealer] = useState('');
    const [selectedDivision, setSelectedDivision] = useState(''); // 'cars' или 'bikes'
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [vehicleFilter, setVehicleFilter] = useState('Все модели');
    const [selectedDateObj, setSelectedDateObj] = useState({ day: null, month: null, year: null });
    const [selectedTime, setSelectedTime] = useState('');

    // СТЭЙТ ДЛЯ ДИНАМИЧЕСКИХ ДАННЫХ С БЭКЕНДА
    const [vehiclesData, setVehiclesData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // СТЭЙТ ДЛЯ МОДАЛЬНОГО ОКНА УВЕДОМЛЕНИЙ
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        type: 'success', // 'success' или 'error'
        message: ''
    });

    const [formData, setFormData] = useState({
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        purchasePlan: 'в течение 1 мес',
        feedbackMethod: 'Нет'
    });

    const [errors, setErrors] = useState({ lastName: '', firstName: '', phone: '', email: '' });

    const SHOWROOMS = [
        {
            id: 1,
            name: 'PREMIUM AUTO',
            address: 'г. Ташкент, Мирабадский район, ул. Авлио Ота 128',
            mapUrl: 'https://yandex.uz/maps/10335/tashkent/?ll=69.281679%2C41.288616&mode=poi&poi%5Bpoint%5D=69.281213%2C41.288841&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D126436150045&z=18.8'
        }
    ];

    const monthsNames = [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ];

    useEffect(() => {
        setIsLoading(true);
        sendFrontAction('test_drive', {}, 'GET') 
            .then(data => {
                if (data && data.success) {
                    setVehiclesData(data.data); 
                    setVehicles(data.data);
                } else {
                    console.error("Ошибка получения данных:", data?.message);
                }
            })
            .catch(error => {
                console.error("Не удалось загрузить транспорт с сервера:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const generateTimeSlots = () => {
        const slots = [];
        let startHour = 10;
        let startMinute = 0;

        while (startHour < 19 || (startHour === 19 && startMinute === 0)) {
            const hStr = String(startHour).padStart(2, '0');
            const mStr = String(startMinute).padStart(2, '0');
            slots.push(`${hStr}:${mStr}`);

            startMinute += 30;
            if (startMinute === 60) {
                startMinute = 0;
                startHour += 1;
            }
        }
        return slots;
    };

    const TIME_SLOTS = generateTimeSlots();

    const daysInMonth = new Date(activeYear, activeMonth + 1, 0).getDate();
    let firstDayIndex = new Date(activeYear, activeMonth, 1).getDay();
    firstDayIndex = firstDayIndex === 0 ? 6 : firstDayIndex - 1;

    const handleNextMonth = () => {
        if (activeMonth === 11) {
            setActiveMonth(0);
            setActiveYear(prev => prev + 1);
        } else {
            setActiveMonth(prev => prev + 1);
        }
        setSelectedTime('');
    };

    const handlePrevMonth = () => {
        if (activeYear === currentYear && activeMonth === currentMonth) return;
        if (activeMonth === 0) {
            setActiveMonth(11);
            setActiveYear(prev => prev - 1);
        } else {
            setActiveMonth(prev => prev - 1);
        }
        setSelectedTime('');
    };

    const isTimeSlotDisabled = (timeStr) => {
        if (selectedDateObj.day !== currentDate || selectedDateObj.month !== currentMonth || selectedDateObj.year !== currentYear) {
            return false;
        }
        const [slotHour, slotMinute] = timeStr.split(':').map(Number);
        const currentHour = todayObj.getHours();
        const currentMin = todayObj.getMinutes();

        if (slotHour < currentHour) return true;
        if (slotHour === currentHour && slotMinute <= currentMin) return true;
        return false;
    };

    const handleBack = () => {
        if (step > 1) setStep(step - 1);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === 'lastName') setErrors(prev => ({ ...prev, lastName: validateName(value) }));
        if (name === 'firstName') setErrors(prev => ({ ...prev, firstName: validateName(value) }));
        if (name === 'phone') setErrors(prev => ({ ...prev, phone: validatePhone(value) }));
        if (name === 'email') setErrors(prev => ({ ...prev, email: validateEmail(value) }));
    };

    const closeModal = () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {
            lastName: validateName(formData.lastName),
            firstName: validateName(formData.firstName),
            phone: validatePhone(formData.phone),
            email: validateEmail(formData.email),
        };
        setErrors(validationErrors);

        if (hasErrors(validationErrors)) {
            setModalConfig({
                isOpen: true,
                type: 'error',
                message: 'Пожалуйста, проверьте правильность заполнения полей формы.'
            });
            return;
        }

        const formattedDay = String(selectedDateObj.day).padStart(2, '0');
        const formattedMonth = String(selectedDateObj.month + 1).padStart(2, '0');
        const fullDateString = `${formattedDay}.${formattedMonth}.${selectedDateObj.year}`;

        const appointmentData = {
            dealer: selectedDealer,
            division: selectedDivision,
            vehicle_name: selectedVehicle?.name,
            date: fullDateString,
            time: selectedTime,
            last_name: formData.lastName,
            first_name: formData.firstName,
            phone: normalizePhoneUZ(formData.phone), // 👈 нормализованный номер
            email: formData.email,
            purchase_plan: formData.purchasePlan,
            feedback_method: formData.feedbackMethod
        };

        try {
            const data = await sendFrontAction('test_drive', appointmentData, 'POST');
            if (data.success) {
                setModalConfig({
                    isOpen: true,
                    type: 'success',
                    message: 'Мы перезвоним вам в ближайшее время для подтверждения записи.'
                });
            } else {
                setModalConfig({
                    isOpen: true,
                    type: 'error',
                    message: data.message || 'Не удалось передать заявку в AmoCRM.'
                });
            }
        } catch (error) {
            console.error("Ошибка при отправке формы:", error);
            setModalConfig({
                isOpen: true,
                type: 'error',
                message: 'Произошла системная ошибка при отправке заявки.'
            });
        }
    };

    const getAvailableFilters = () => {
        const filteredByDivision = vehiclesData.filter(v => v.type === selectedDivision);
        const filters = new Set(filteredByDivision.map(v => v.filter).filter(Boolean));
        return ['Все модели', ...Array.from(filters)];
    };

    return (
        <div className="td-container">
            <h1 className="td-main-title">ОНЛАЙН-ЗАПИСЬ НА ТЕСТ-ДРАЙВ</h1>

            {/* Хлебные крошки */}
            {step > 1 && (
                <div className="td-navigation">
                    <button className="td-back-button" onClick={handleBack}>
                        <span className="arrow-left">‹</span> Назад
                    </button>
                    <div className="td-breadcrumbs">
                        <span>{selectedDealer}</span>
                        {step >= 3 && <span> / {selectedDivision === 'cars' ? 'Автомобили BMW' : 'Мотоциклы BMW Motorrad'}</span>}
                        {step >= 4 && selectedVehicle && <span> / {selectedVehicle.name}</span>}
                    </div>
                </div>
            )}

            {/* ШАГ 1: ВЫБОР ДИЛЕРА */}
            {step === 1 && (
                <div className="td-step-wrapper">
                    <p className="td-step-label">Выберите шоурум</p>
                    {SHOWROOMS.map((dealer) => (
                        <div
                            key={dealer.id}
                            className="td-dealer-card"
                            onClick={() => {
                                setSelectedDealer(dealer.name);
                                setStep(2);
                            }}
                        >
                            <div className="td-dealer-header">
                                <div className="td-dealer-logo">
                                    <span className="td-logo-text">{dealer.name}</span>
                                    <div className="td-bmw-mini-logo"></div>
                                </div>
                            </div>

                            <div className="td-dealer-footer">
                                <span className="td-dealer-address">
                                    {dealer.address}
                                </span>

                                <a
                                    href={dealer.mapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="map-link"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    На карте
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* ШАГ 2: ВЫБОР ПОДРАЗДЕЛЕНИЯ */}
            {step === 2 && (
                <div className="td-step-wrapper">
                    <p className="td-step-label">Выберите подразделение</p>
                    <div className="td-division-grid-modern">
                        <div className="td-division-card-modern" onClick={() => { setSelectedDivision('cars'); setVehicleFilter('Все модели'); setStep(3); }}>
                            <div className="td-div-image-bg bg-cars"></div>
                            <div className="td-div-info-overlay">
                                <span className="td-div-name-modern">Автомобили BMW</span>
                            </div>
                        </div>
                        <div className="td-division-card-modern" onClick={() => { setSelectedDivision('bikes'); setVehicleFilter('Все модели'); setStep(3); }}>
                            <div className="td-div-image-bg bg-bikes"></div>
                            <div className="td-div-info-overlay">
                                <span className="td-div-name-modern">Мотоциклы BMW Motorrad</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ШАГ 3: ВЫБОР ТРАНСПОРТА */}
            {step === 3 && (
                <div className="td-step-wrapper">
                    <p className="td-step-label">Выберите {selectedDivision === 'cars' ? 'автомобиль' : 'мотоцикл'}</p>
                    
                    <div className="td-filter-tabs">
                        {getAvailableFilters().map(tab => (
                            <button 
                                key={tab} 
                                className={`td-tab-btn ${vehicleFilter === tab ? 'active' : ''}`}
                                onClick={() => setVehicleFilter(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    {isLoading ? (
                        <div className="td-loader">Загрузка автопарка...</div>
                    ) : (
                        <div className="td-vehicles-grid">
                            {vehiclesData
                                .filter(v => v.type === selectedDivision && (vehicleFilter === 'Все модели' || v.filter === vehicleFilter))
                                .map(v => (
                                    <div 
                                        key={`${v.type}-${v.id}`} 
                                        className={`td-vehicle-card ${selectedVehicle?.id === v.id && selectedVehicle?.type === v.type ? 'selected' : ''}`}
                                        onClick={() => { setSelectedVehicle(v); setStep(4); }}
                                    >
                                        <h3 className="td-vehicle-name">{v.name}</h3>
                                        
                                        {v.price && (
                                            <p className="td-vehicle-price">
                                                От {isNaN(parseFloat(v.price)) ? v.price : parseFloat(v.price).toLocaleString('ru-RU')} €
                                            </p>
                                        )}
                                        
                                        <div className="td-vehicle-image-wrapper">
                                            <img 
                                                src={getBackendFileUrl(v.image)} 
                                                alt={v.name} 
                                                className="td-vehicle-img" 
                                                    onError={(e) => {
                                                        if (e.target.dataset.fallbackApplied) return; // 👈 не повторять, если уже подставили заглушку
                                                        e.target.dataset.fallbackApplied = 'true';
                                                        e.target.src = selectedDivision === 'cars'
                                                            ? '/assets/no-photo.jpg' // 👈 используем локальную заглушку, а не внешний домен
                                                            : '/assets/no-photo.jpg';
                                                    }}
                                            />
                                        </div>

                                        <div className="td-vehicle-specs">
                                            {v.power && <span className="td-spec-item">{v.power} л.с.</span>}
                                            {v.transmission && <span className="td-spec-item">{v.transmission}</span>}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            )}

            {/* ШАГ 4: КАЛЕНДАРЬ И ВРЕМЯ */}
            {step === 4 && (
                <div className="td-step-wrapper">
                    <div className="td-calendar-navigation">
                        <button 
                            type="button"
                            className={`td-month-nav-btn ${activeYear === currentYear && activeMonth === currentMonth ? 'disabled' : ''}`}
                            onClick={handlePrevMonth}
                            disabled={activeYear === currentYear && activeMonth === currentMonth}
                        >
                            ‹
                        </button>
                        <h2 className="td-calendar-title">{monthsNames[activeMonth]} {activeYear}</h2>
                        <button 
                            type="button"
                            className="td-month-nav-btn"
                            onClick={handleNextMonth}
                        >
                            ›
                        </button>
                    </div>
                    
                    <div className="td-calendar-grid">
                        {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map(d => <div key={d} className="td-day-header">{d}</div>)}
                        {Array.from({ length: firstDayIndex }).map((_, idx) => (
                            <div key={`empty-${idx}`} className="td-calendar-day empty"></div>
                        ))}
                        {Array.from({ length: daysInMonth }).map((_, i) => {
                            const day = i + 1;
                            const isPast = activeYear === currentYear && activeMonth === currentMonth && day < currentDate;
                            const isSelected = selectedDateObj.day === day && selectedDateObj.month === activeMonth && selectedDateObj.year === activeYear;

                            return (
                                <div 
                                    key={day} 
                                    className={`td-calendar-day ${isSelected ? 'active-day' : ''} ${isPast ? 'disabled-day' : ''}`}
                                    onClick={() => { 
                                        if(!isPast) { 
                                            setSelectedDateObj({ day, month: activeMonth, year: activeYear }); 
                                            setSelectedTime(''); 
                                        } 
                                    }}
                                >
                                    {day}
                                </div>
                            );
                        })}
                    </div>

                    {selectedDateObj.day && (
                        <div className="td-time-slots-section">
                            <p className="td-step-label">Выберите время</p>
                            <div className="td-time-grid">
                                {TIME_SLOTS.map(time => {
                                    const isDisabled = isTimeSlotDisabled(time);
                                    return (
                                        <button 
                                            key={time} 
                                            disabled={isDisabled}
                                            className={`td-time-btn ${selectedTime === time ? 'active-time' : ''} ${isDisabled ? 'time-disabled' : ''}`}
                                            onClick={() => setSelectedTime(time)}
                                        >
                                            {time}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {selectedTime && (
                        <div className="td-action-footer">
                            <button className="td-primary-btn" onClick={() => setStep(5)}>
                                Далее <span className="arrow-right">➔</span>
                            </button>
                        </div>
                    )}
                </div>
            )}

            {/* ШАГ 5: ФОРМА */}
            {step === 5 && (
                <form onSubmit={handleSubmit} className="td-step-wrapper td-form">
                    <div className="td-form-group">
                        <label>Фамилия *</label>
                        <input
                            type="text"
                            name="lastName"
                            required
                            value={formData.lastName}
                            onChange={handleInputChange}
                            className={errors.lastName ? 'field-invalid' : ''}
                        />
                        {errors.lastName && <span className="field-error">{errors.lastName}</span>}
                    </div>

                    <div className="td-form-group">
                        <label>Имя *</label>
                        <input
                            type="text"
                            name="firstName"
                            required
                            value={formData.firstName}
                            onChange={handleInputChange}
                            className={errors.firstName ? 'field-invalid' : ''}
                        />
                        {errors.firstName && <span className="field-error">{errors.firstName}</span>}
                    </div>

                    <div className="td-form-group">
                        <label>Телефон *</label>
                        <input
                            type="tel"
                            name="phone"
                            placeholder="+998 XX XXX XX XX"
                            required
                            value={formData.phone}
                            onChange={handleInputChange}
                            className={errors.phone ? 'field-invalid' : ''}
                        />
                        {errors.phone && <span className="field-error">{errors.phone}</span>}
                    </div>

                    <div className="td-form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className={errors.email ? 'field-invalid' : ''}
                        />
                        {errors.email && <span className="field-error">{errors.email}</span>}
                    </div>

                    <div className="td-form-notes">
                        <p>** Обращаем внимание, к тест-драйву допускаются лица имеющие стаж вождения более 2 лет</p>
                        <p>** Необходимо наличие прав при визите</p>
                    </div>

                    <div className="td-form-group">
                        <label className="td-section-heading">Когда планируете покупку?</label>
                        <div className="td-radio-group-grid">
                            {['в течение 1 мес', 'в течение 6 мес', 'в течение 12 мес', 'не планирую покупку'].map(plan => (
                                <label key={plan} className="td-radio-row">
                                    <input 
                                        type="radio" 
                                        name="purchasePlan" 
                                        value={plan} 
                                        checked={formData.purchasePlan === plan} 
                                        onChange={handleInputChange} 
                                    />
                                    <span>{plan}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Блок сводки записи */}
                    <div className="td-summary-card">
                        <h3 className="td-summary-title">
                            Ваша запись на {String(selectedDateObj.day).padStart(2, '0')}.{String(selectedDateObj.month + 1).padStart(2, '0')}.{selectedDateObj.year} ({new Date(selectedDateObj.year, selectedDateObj.month, selectedDateObj.day).toLocaleDateString('ru-RU', { weekday: 'long' })}), {selectedTime}
                        </h3>
                        <div className="td-summary-item-info">
                            <div className="td-summary-thumb-img">
                                <img src={getBackendFileUrl(selectedVehicle?.image)} alt={selectedVehicle?.name} />
                            </div>
                            <div>
                                <p className="td-summary-name">{selectedVehicle?.name}</p>
                                <p className="td-summary-dep">{selectedDivision === 'cars' ? 'Автомобиль BMW' : 'Мотоциклы BMW Motorrad'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="td-form-group">
                        <label className="td-section-heading">Необходима ли Вам обратная связь?*</label>
                        <div className="td-radio-inline">
                            {['Нет', 'Да (телефон)', 'Telegram', 'Email'].map(method => (
                                <label key={method} className="td-radio-row">
                                    <input 
                                        type="radio" 
                                        name="feedbackMethod" 
                                        value={method} 
                                        checked={formData.feedbackMethod === method} 
                                        onChange={handleInputChange} 
                                    />
                                    <span>{method}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <p className="td-required-notice">* Обязательные для заполнения поля</p>

                    <button type="submit" className="td-primary-btn td-submit-btn">
                        Отправить
                    </button>
                </form>
            )}

            {/* ВСПЛЫВАЮЩЕЕ МОДАЛЬНОЕ ОКНО */}
            {modalConfig.isOpen && (
                <div className="td-modal-overlay" onClick={closeModal}>
                    <div className="td-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="td-modal-close" onClick={closeModal}>×</button>
                        
                        {/* Картинка выбранного авто */}
                        {selectedVehicle && (
                            <div className="td-modal-vehicle-img-wrapper">
                                <img 
                                    src={getBackendFileUrl(selectedVehicle.image)} 
                                    alt={selectedVehicle.name} 
                                    className="td-modal-vehicle-img"
                                        onError={(e) => {
                                            if (e.target.dataset.fallbackApplied) return; // 👈 не повторять, если уже подставили заглушку
                                            e.target.dataset.fallbackApplied = 'true';
                                            e.target.src = selectedDivision === 'cars'
                                                ? '/assets/no-photo.jpg' // 👈 используем локальную заглушку, а не внешний домен
                                                : '/assets/no-photo.jpg';
                                        }}
                                />
                            </div>
                        )}

                        {/* Текст уведомления */}
                        {modalConfig.type === 'success' ? (
                            <>
                                <h2 className="td-modal-title">Спасибо за заявку!</h2>
                                <p className="td-modal-subtitle">{modalConfig.message}</p>
                            </>
                        ) : (
                            <>
                                <h2 className="td-modal-title error">Произошла ошибка</h2>
                                <p className="td-modal-subtitle">{modalConfig.message}</p>
                            </>
                        )}

                        <button className="td-primary-btn td-modal-btn" onClick={closeModal}>
                            Закрыть
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TestDriveAppointment;